import React from 'react';

const Facility = () => {
    const facilities = [
        {
            icon: "fa-mug-hot",
            title: "Hạt Cà Phê Nguyên Chất",
            desc: "Tuyển chọn từ những vùng hạt chất lượng cao, rang xay thủ công, giữ trọn hương vị đậm đà nguyên bản."
        },
        {
            icon: "fa-shield-halved",
            title: "Vệ Sinh & Chuẩn Vị",
            desc: "Dụng cụ phin nhôm truyền thống và nguồn nước được lọc sạch kỹ càng, đảm bảo an toàn vệ sinh thực phẩm tối đa."
        },
        {
            icon: "fa-hand-holding-heart",
            title: "Giá Cả Chân Phương",
            desc: "Mức giá bình dân, thân thiện và minh bạch, mang lại trải nghiệm thưởng thức cà phê trọn vẹn cho mọi người."
        },
        {
            icon: "fa-sun",
            title: "Mở Cửa Sớm 4h30 Sáng",
            desc: "Phục vụ từ sáng sớm tinh sương, lý tưởng để đón bình minh biển Phước Hải và nạp năng lượng cho ngày mới."
        }
    ];

    return (
        <section className="facility-section" id="facility">
            <div className="section-header">
                <span className="section-tag">Giá Trị Cốt Lõi</span>
                <h2>Vì Sao Khách Hàng Chọn <span>Café 9?</span></h2>
                <p>Những giá trị mộc mạc làm nên thương hiệu được yêu mến suốt hơn 40 năm qua tại Phước Hải.</p>
                <div className="header-divider">
                    <i className="fas fa-seedling"></i>
                </div>
            </div>

            <div className="values-grid">
                {facilities.map((item, index) => (
                    <div key={index} className="value-card">
                        <div className="value-icon-circle">
                            <i className={`fa-solid ${item.icon}`}></i>
                        </div>
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Facility;